
import { forkJoin as observableForkJoin, Observable, forkJoin } from 'rxjs';
import { Component, OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { LoginDataService } from "app/login/login-data.service";
import { UserResource } from "app/resources/user/user-resource";
import { MyProfileService } from "app/user/my-profile/my-profile.service";
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { CompanyListResource } from "app/resources/company/company-list-resource";
import { RoleResource } from "app/resources/role/role-resource";
import { CompanyResource } from "app/resources/company/company-resource";
import { RoleListResource } from "app/resources/role/role-list-resource";
import { UserChangePasswordResource } from "app/resources/user/UserChangePasswordResource";
import { AdminProfileResource } from "app/models/AdminProfileResource";
import { NotificationsService } from "angular2-notifications";
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'app/message-service.service';
import { UtilsService } from 'app/services/utils.service';

@Component({
	selector: 'vbn-my-profile',
	templateUrl: './my-profile.component.html',
	styleUrls: ['./my-profile.component.scss'],
	providers: [MyProfileService],
})
export class MyProfileComponent implements OnInit {


	@ViewChild('avatarinput') avatarinput: ElementRef;
	@ViewChild('avatarnewimg') avatarnewimg: ElementRef;


	companyListResource: CompanyListResource;
	loggedUser: string = atob(localStorage.getItem('_user'));
	errorMessage: string;
	userResource: UserResource;
	//roleListResource: RoleListResource;
	showSuccessAlert: boolean = true;
	private timer;
	genderList = [{
		rid: 1,
		nameEn: "Male"
	},
	{
		rid: 2,
		nameEn: "Female"
	}];
	changePass: boolean = false;
	oldPassword: string;
	newPassword: string;
	confirmPassword: string;
	changePasswordObj: UserChangePasswordResource;
	oldPassErr: boolean = false;
	newPassErr: boolean = false;
	//adminProfileResource: AdminProfileResource;
	showModal = false;
	saveErrors: boolean = false
	saveErrorsSubmit: boolean = false
	newOldPass: boolean = false;
	selected_language: string = "ro";
	logoLang: any;
	dateNow: Date;
	userRoleId = localStorage.getItem("_roleId");
	editForm: FormGroup;

	constructor(
		private _login: LoginDataService,
		private myProfileService: MyProfileService,
		private element: ElementRef,
		private fb: FormBuilder,
		private _notificationService: NotificationsService,
		private translate: TranslateService,
		private messageService: MessageService,
		private utilsService: UtilsService) {
		this.userResource = new UserResource();
		this.userResource.role = new RoleResource();
		this.userResource.company = new CompanyResource();
		//this.roleListResource = new RoleListResource();
		this.companyListResource = new CompanyListResource();
		//this.adminProfileResource = new AdminProfileResource();
		this.changePasswordObj = new UserChangePasswordResource();
		this.dateNow = new Date();
		this.logoLang = '0';
	}

	ngOnInit() {

		this.editForm = this.fb.group({
			firstName: ['', [Validators.required, Validators.maxLength(50), Validators.pattern('^[a-zA-Z ]{3,50}$')]],
			lastName: ['', [Validators.required, Validators.maxLength(50), Validators.pattern('^[a-zA-Z ]{3,50}$')]],
			companyName: ['', []],
			function: ['', []],
			email: ['', [Validators.nullValidator]],
			phone: ['', [Validators.nullValidator]],
			address: ['', [Validators.nullValidator]],
			registrationDate: ['', [Validators.nullValidator]],
			updateDate: ['', [Validators.nullValidator]],
			role: ['', [Validators.nullValidator]],
			smtpEmail: ['', [Validators.maxLength(100), Validators.email]],
			smtpPassword: ['', [Validators.minLength(8)]],
		})



		this.getUserProfile(this.loggedUser);
		this.getAllCompany();
		//	this.getUserRoles(); /* Does not seems to be used anyware the received info */
		//this.getAdminProfile();
	}



	changePassForm = this.fb.group({
		oldPassword: ['', [Validators.required]],
		newPassword: ['', [Validators.required]],
		confirmPassword: ['', [Validators.required]]
	})

	closeModal() {
		this.showModal = false;
	}

	//close login modal on ESC keypress
	@HostListener('document:keypress', ['$event'])
	closeModalEscape(event: KeyboardEvent) {
		if (event.keyCode === 27) {
			this.closeModal();
		}
	}

	showModalContainer() {
		this.saveErrors = false
		this.showModal = true;
	}

	/* 	getAdminProfile() {
			this.myProfileService.getAdminProfile('admin/profile/get')
				.subscribe(
				response => {
					this.adminProfileResource = response;
				},
				error => this.errorMessage = <any>error);
		} */

	getUserProfile(email: string) {
		this.myProfileService.getUserProfile('/admin/user/getProfile?userName=' + email)
			.subscribe(
				response => {
					this.userResource = response;
					if (this.userResource.isOneLogo) {
						this.logoLang = '0';
					} else {
						this.logoLang = '1';
					}
					if (this.userResource.role.rid !== 5) {
						this.editForm.get("companyName").setValidators([Validators.required, Validators.maxLength(50), Validators.pattern('^[a-zA-Z ]{3,50}$')])
					} else {
						this.editForm.controls["function"].setValidators([Validators.required, Validators.maxLength(50), Validators.minLength(3), this.utilsService.NoWhitespaceValidator()])
					}
				},
				error => this.errorMessage = <any>error);
	}

	getAllCompany() {
		this.myProfileService.getAllCompany('/admin/company/findAll')
			.subscribe(
				response => {
					this.companyListResource = response;
				},
				error => this.errorMessage = <any>error);
	}

	/* 	getUserRoles() {
			this.myProfileService.getUserRoles('/admin/role/getAll')
				.subscribe(
				response => {
					this.roleListResource = response;
					//console.log("User roles: ", this.roleListResource)
				},
				error => this.errorMessage = <any>error);
		} */

	onSubmit() {

		this.saveErrorsSubmit = true

		if (!this.editForm.valid) {
			observableForkJoin(
				this.translate.get('Mising fields'),
				this.translate.get('Please fill out the fields!')
			).subscribe((res) => {
				this._notificationService.create(res[0], res[1], 'error')
			})
			//this._notificationService.create("Mising fields", 'Please fill out the fields!', 'error')
			return
		}

		//Logo validation
		if (this.userResource.role.rid != 5) { // roleId = 5  => officer. The officers can not set the company logo
			if (this.logoLang === '0' && (this.userResource.logoStringRo == null && this.userResource.logoRo == null)) {
				observableForkJoin(
					[this.translate.get('Mising fields'),
					this.translate.get('Please upload the logo RO!')]
				).subscribe((res) => {
					this._notificationService.create(res[0], res[1], 'error')
				})
				return
			}
			if (this.logoLang === '1' &&
				((this.userResource.logoStringRo == null && this.userResource.logoRo == null) ||
					this.userResource.logoStringEn == null ||
					this.userResource.logoStringFr == null ||
					this.userResource.logoStringDe == null) &&
				(this.userResource.logoRo == null ||
					this.userResource.logoEn == null ||
					this.userResource.logoFr == null ||
					this.userResource.logoDe == null)) {
				observableForkJoin(
					[this.translate.get('Mising fields'),
					this.translate.get('Please upload the logo for all languages!')]
				).subscribe((res) => {
					this._notificationService.create(res[0], res[1], 'error')
				})
				return
			}
		}

		this.userResource.isOneLogo = (this.logoLang === '0') ? true : false;

		console.log("A trimis user-ul: ", this.userResource)
		this.myProfileService.editUser('/admin/user/updateProfile', this.userResource)
			.subscribe(
				response => {
					if (response.errorCode == 1049) {
						observableForkJoin(
							this.translate.get('Error'),
							this.translate.get('SMTP data are not correct!')
						).subscribe((res) => {
							this._notificationService.create(res[0], res[1], 'error')
						})
					} else {
						this.userResource = response;
						this.showSuccessAlert = false;
						this.userResource.image = this.userResource.image !== null ? this.userResource.image.split("?")[0] + "?" + Date.now() : null
						this.avatarinput.nativeElement.value = "";
						this.avatarnewimg.nativeElement.src = "";
						// this.timer = setTimeout(() => {
						// 	this.showSuccessAlert = true;
						// }, 5000);
						observableForkJoin(
							this.translate.get('Success'),
							this.translate.get('Successfully saved!')
						).subscribe((res) => {
							this._notificationService.create(res[0], res[1], 'success')
						})
						this.messageService.sendMessage({
							type: "updateUser",
							content: this.userResource
						});
					}

				},
				error => this.errorMessage = <any>error);
	}

	changeListener($event): void {
		var file: File = $event.target.files[0];
		if ((file.type.slice(0, 9) === "image/jpg") || (file.type.slice(0, 9) === "image/JPG") ||
			(file.type.slice(0, 10) === "image/jpeg") || (file.type.slice(0, 10) === "image/JPEG") ||
			(file.type.slice(0, 9) === "image/png") || (file.type.slice(0, 9) === "image/PNG") ||
			(file.type.slice(0, 9) === "image/gif") || (file.type.slice(0, 9) === "image/GIF")) {
			var myReader: FileReader = new FileReader();
			var image = this.element.nativeElement.querySelector('#fileupload');
			myReader.onloadend = (e: any) => {
				image.src = e.target.result;
				this.userResource.imageString = e.target.result;
			}
			myReader.readAsDataURL(file);
		} else {
			observableForkJoin(
				this.translate.get('Image error'),
				this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF!')
			).subscribe((res) => {
				this._notificationService.create(res[0], res[1], 'error')
			})

			//this._notificationService.create("Image error", 'Only these formats of image are allowed: JPG, JPEG, PNG, GIF!', 'error')
		}
	}

	isNumber(evt) {
		evt = (evt) ? evt : window.event;
		var charCode = (evt.which) ? evt.which : evt.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}

	change() {

		this.saveErrors = true


		if (this.oldPassword == this.newPassword) {
			this.newOldPass = true;
			return
		}

		if (!this.changePassForm.valid) {
			observableForkJoin(
				this.translate.get('Mising fields'),
				this.translate.get('Please fill out the fields!')
			).subscribe((res) => {
				this._notificationService.create(res[0], res[1], 'error')
			})
			return
		}

		if (this.newPassword == this.confirmPassword) {
			this.changePasswordObj.email = this.loggedUser;
			this.changePasswordObj.oldPassword = this.oldPassword;
			this.changePasswordObj.newPassword = this.newPassword;
			this.myProfileService.changePassword('/admin/user/changePassword', this.changePasswordObj)
				.subscribe(
					response => {
						this.changePassForm.reset()
						this.saveErrors = false
						this.showModal = false

						observableForkJoin(
							this.translate.get('Success'),
							this.translate.get('Password changed with success!')
						).subscribe((res) => {
							this._notificationService.create(res[0], res[1], 'success')
						});


						// this._notificationService.create("Success", `Password changed with success!`, 'success')

						this.changePasswordObj = response;
						//this.changePass = true;
						//this.clear();
						// this.timer = setTimeout(() => {
						// 	this.changePass = false;
						// }, 5000);
					},
					error => {
						this.changePassForm.reset()
						this.saveErrors = false

						observableForkJoin(
							this.translate.get('Error'),
							this.translate.get('Old password is incorrect!')
						).subscribe((res) => {
							this._notificationService.create(res[0], res[1], 'error')
						});

						//this._notificationService.create("Error", 'Old password is incorrect!', 'error')

						// if (error.errorCode == 1016) {
						// 	this.oldPassErr = true;
						// 	this.timer = setTimeout(() => {
						// 		this.oldPassErr = false;
						// 	}, 5000);
						// }
					});
		} else {
			this.changePassForm.reset()
			this.saveErrors = false

			observableForkJoin(
				this.translate.get('Error'),
				this.translate.get(`The new password and confirmation password don't match!`)
			).subscribe((res) => {
				this._notificationService.create(res[0], res[1], 'error')
			});


			//this._notificationService.create("Error", `The new password and confirmation password don't match!`, 'error')

			// this.newPassErr = true;
			// this.timer = setTimeout(() => {
			// 	this.newPassErr = false;

			// }, 5000);
		}

	}
	// clear() {
	// 	this.oldPassword = "";
	// 	this.newPassword = "";
	// 	this.confirmPassword = "";
	// }

	changeListenerMainImage($event, lang): void {
		console.log("FFEFFF: ", $event)
		var file: File = $event.target.files[0];
		var myReader: FileReader = new FileReader();
		var image = this.element.nativeElement.querySelector('#documentInput' + lang);
		if ((file.type.slice(0, 9) === "image/jpg") || (file.type.slice(0, 9) === "image/JPG") ||
			(file.type.slice(0, 10) === "image/jpeg") || (file.type.slice(0, 10) === "image/JPEG") ||
			(file.type.slice(0, 9) === "image/png") || (file.type.slice(0, 9) === "image/PNG") ||
			(file.type.slice(0, 9) === "image/gif") || (file.type.slice(0, 9) === "image/GIF")) {
			if (file.size < 1000000) {
				myReader.onloadend = (e: any) => {
					image.src = e.target.result;
					console.log("eddddddddddddddd", image);
					this.userResource["logoString" + lang] = e.target.result;
				}
				myReader.readAsDataURL(file);
			} else {
				forkJoin(
					this.translate.get('Image error'),
					this.translate.get('Image size is more than 1 mb!')
				).subscribe((res) => {
					this._notificationService.create(res[0], res[1], 'error')
				})
			}
		} else {
			forkJoin(
				this.translate.get('Image error'),
				this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF!')
			).subscribe((res) => {
				this._notificationService.create(res[0], res[1], 'error')
			})
		}
	}

}
